class GuajaEmailGate extends HTMLElement {
  constructor() {
    super();

    this.cookieName = "Guaja:email-gate";
    this.cookieDays = parseInt(this.dataset.cookieDays, 10) || 30;
    this.cookie = typeof getCookie === "function" ? getCookie(this.cookieName) : "";

    this.modal = this.querySelector(".m-modal");
    this.onKeydown = this.onKeydown.bind(this);
    this.onKlaviyoForms = this.onKlaviyoForms.bind(this);
    this.__shopifySectionSelect = this.__shopifySectionSelect.bind(this);
    this.__shopifySectionLoad = this.__shopifySectionLoad.bind(this);
  }

  connectedCallback() {
    if (this.dataset.enable === "true" && this.cookie === "") {
      if (!(window.Shopify && Shopify.designMode)) {
        this.openPopup();
      }
    }

    window.addEventListener("klaviyoForms", this.onKlaviyoForms);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener("shopify:section:select", this.__shopifySectionSelect);
      document.addEventListener("shopify:section:load", this.__shopifySectionLoad);
    }
  }

  disconnectedCallback() {
    this.unlockScroll();
    document.removeEventListener("keydown", this.onKeydown, true);
    window.removeEventListener("klaviyoForms", this.onKlaviyoForms);

    if (window.Shopify && Shopify.designMode) {
      document.removeEventListener("shopify:section:select", this.__shopifySectionSelect);
      document.removeEventListener("shopify:section:load", this.__shopifySectionLoad);
    }
  }

  onKlaviyoForms(event) {
    const type = event.detail && event.detail.type;
    if (
      type === "submit" ||
      type === "embedFormSubmitSuccess" ||
      type === "redirectToUrl" ||
      type === "success"
    ) {
      this.unlock();
    }
  }

  onKeydown(event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  unlock() {
    if (this.dataset.enable === "true" && typeof setCookie === "function") {
      setCookie(this.cookieName, "unlocked", this.cookieDays);
    }
    this.closePopup();
  }

  openPopup() {
    if (!this.modal) return;
    this.modal.style.setProperty("--m-opacity", "1");
    this.modal.classList.add("m-open-modal");
    document.documentElement.classList.add("prevent-scroll");
    document.addEventListener("keydown", this.onKeydown, true);
  }

  closePopup() {
    if (!this.modal) return;
    this.modal.classList.remove("m-open-modal");
    this.modal.style.setProperty("--m-opacity", "0");
    this.unlockScroll();
    document.removeEventListener("keydown", this.onKeydown, true);
  }

  unlockScroll() {
    document.documentElement.classList.remove("prevent-scroll");
  }

  __shopifySectionLoad(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.dataset.designMode === "true") {
      this.openPopup();
    }
  }

  __shopifySectionSelect(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.dataset.designMode === "true") {
      this.openPopup();
    } else if (event.detail.sectionId === this.dataset.sectionId) {
      this.closePopup();
    } else {
      this.closePopup();
    }
  }
}

customElements.define("guaja-email-gate", GuajaEmailGate);
